import { render } from "./AuthorizedSignatoryDetailsForm.vue?vue&type=template&id=3dfafb70&scoped=true"
import script from "./AuthorizedSignatoryDetailsForm.vue?vue&type=script&lang=js"
export * from "./AuthorizedSignatoryDetailsForm.vue?vue&type=script&lang=js"

import "./AuthorizedSignatoryDetailsForm.vue?vue&type=style&index=0&id=3dfafb70&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfafb70"]])

export default __exports__